import {Component, Input, OnChanges, OnInit } from '@angular/core';
import { TravelArticle } from '../models/travel-article.model';
import { TravelArticlesService } from '../services/travel-articles.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-travel-articles',
  templateUrl: './travel-articles.component.html',
  styleUrls: ['./travel-articles.component.scss']
})
export class TravelArticlesComponent implements OnInit, OnChanges {
  @Input() airportIdent: string;
  travelArticles: TravelArticle[];
  isLoading = false;

  constructor(private _travelArticleService: TravelArticlesService) { }

  async ngOnInit() {
    this.isLoading = true;
    if (this.airportIdent != null) {
      this.travelArticles = await this._travelArticleService.getArticles(this.airportIdent.toLowerCase().trim());
    }
    this.isLoading = false;
  }

  async ngOnChanges() {
    this.isLoading = true;
    if (this.airportIdent != null) {
      this.travelArticles = await this._travelArticleService.getArticles(this.airportIdent.toLowerCase().trim());
    }
    this.isLoading = false;
  }
}
